import { z } from 'zod';

export const $UserFormEditValidate = z.object({
  firstName: z.string().min(1, 'Имя обязательно для заполнения'),
  lastName: z.string().min(1, 'Фамилия обязательна для заполнения'),
  email: z.string().email('Некорректный email'),
  phone: z.string().optional(),
  role: z
    .string({ message: 'Группа обязательна для заполнения' })
    .min(1, 'Группа обязательна для заполнения'),
  companyId: z.string().optional().nullable(),
});
export type UserFormEditValidate = z.infer<typeof $UserFormEditValidate>;

export type UserFormValues = {
  avatarId: number | null;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: string;
  companyId?: string;
};

export type UserFormInitialValues = Omit<UserFormValues, 'phone'> & {
  phone?: string | null;
};
